import { FlexflowCardStatus } from '../../types';
import { useFormState } from 'react-final-form';
import ContractStatusBeforeInvitation, {
  FlexflowEmployeeStatusesBeforeActivation
} from '../../Contracts/ContractStatusBeforeInvitation';
import ContractFlexflowStatusAfterInvitation, {
  type ContractPayflowStatus
} from '../../Contracts/ContractStatusAfterInvitation';
import { type Employee } from 'src/shared/types/employee';
import { type FlexflowEmployeeDataToDisplay } from '../../Contracts/types';
import { getStatus } from '../../utils/getStatus';
import { type CardStatusToDisplay } from '../../EmployeeDetails/types';

const EmployeeFlexflowStatus = ({ cardStatus }: { cardStatus?: CardStatusToDisplay }) => {
  const { values } = useFormState();
  const status = getStatus(values as Employee | FlexflowEmployeeDataToDisplay);
  const beforeActivation =
    Object.values(FlexflowEmployeeStatusesBeforeActivation).includes(
      status as unknown as FlexflowEmployeeStatusesBeforeActivation
    ) || values?.card?.status === FlexflowCardStatus.TERMINATED;

  return beforeActivation ? (
    <ContractStatusBeforeInvitation flexflowStatus={status} />
  ) : (
    <ContractFlexflowStatusAfterInvitation
      payflowStatus={status as ContractPayflowStatus}
      flexflowCardStatus={cardStatus ?? values?.card?.status}
      cardSuspendedBySwan={values?.cardSuspendedBySwan}
    />
  );
};

export default EmployeeFlexflowStatus;
